import React, {useState} from 'react'
import gql from 'graphql-tag'
import {Mutation} from 'react-apollo'
import get from 'lodash.get'
import upperFirst from 'lodash.upperfirst'
import SortableList from 'components/shared/SortableList'
import Button from 'components/shared/Button'

const setSlideshowInputMutation = gql`
  mutation SetSlideshowInput($input: SetSlideshowInputInput!) {
    SetSlideshowInput(input: $input) {
      product {
        id
        state
        requiresUserInput
        canProvideUserInput
        ...on SlideshowProduct {
          roomsPriority
        }
      }
    }
  }
`

const ChooseRoomsPriority = ({product, setStep}) => {
  const inputAssets = product.inputAssets.edges.map(e => e.node)
  const uniqueRoomNames = inputAssets
    .map((asset) => upperFirst(get(asset, 'image.labels[0]', '')))
    .filter((room, i, a) => a.indexOf(room) === i)

  const [selectedRooms, setSelectedRooms] = useState(uniqueRoomNames)

  const hasRoomsPriority = product.roomsPriority && product.roomsPriority.length > 0

  return (
    <div className="rooms-list">
      <SortableList
        labels={selectedRooms}
        onUpdate={setSelectedRooms}
        sortable={!hasRoomsPriority}
      />

      {!hasRoomsPriority && (
        <Mutation
          mutation={setSlideshowInputMutation}
        >
          {(setSlideshowInput, {loading}) => (
            <Button
              type="action"
              loading={loading}
              disabled={loading}
              onClick={() => {
                setSlideshowInput({
                  variables: {
                    input: {
                      productId: product.id,
                      rooms: selectedRooms,
                    }
                  }
                }).then(() => {
                  setStep('broker')
                })
              }}
            >
              Velg romprioritering
            </Button>
          )}
        </Mutation>
      )}
    </div>
  )
}

export default ChooseRoomsPriority
